import React from "react";
import StatusIndicator from "./status";
import { CopyValue } from "../..";
import { approvalQueueCopy } from "../../../Utils/approvalRuleCopy";

function ApprovalStatus({ status, id, trail, inSequence }) {
	const progress = status === "pending" ? approvalQueueCopy(trail, inSequence) : null;
	return (
		<div className="p-2 border-t bg-whitish">
			{/* change start by cursor */}
			<div className="flex flex-wrap items-center justify-between gap-2">
				{id ? <CopyValue className="min-w-0 text-xxs">{id}</CopyValue> : <span />}
				<span className="shrink-0">
					<StatusIndicator status={status} label={progress?.badge} />
				</span>
			</div>
			{progress?.note ? <div className="mt-1 break-words text-xxs text-secondary">{progress.note}</div> : null}
			{/* change end by cursor */}
		</div>
	);
}

export default ApprovalStatus;
